export const REVEAL_FACE_DELAY = 1500;
